export default __webpack_public_path__ + "static/media/tesvik_sorgulama_ornek_excel.27107676.xlsx";